import { NgModule } from '@angular/core';
import { MenuModule } from '@app/menu/menu.module';
import { MaintenanceMessagesComponent } from '@app/portal/components/maintenance-messages/maintenance-messages.component';
import { PortalContainerComponent } from '@app/portal/components/portal-container/portal-container.component';
import { PortalFooterComponent } from '@app/portal/components/portal-footer/portal-footer.component';
import { PortalHeaderComponent } from '@app/portal/components/portal-header/portal-header.component';
import { PortalPageComponent } from '@app/portal/components/portal-page/portal-page.component';
import { ToastComponent } from '@app/portal/components/toast/toast.component';
import { ToastsComponent } from '@app/portal/components/toasts/toasts.component';
import { LogLevelCommandComponent } from '@app/shared/quick-commands/commands/log-level.command.component';
import { SharedModule } from '@app/shared/shared.module';
import { MyNotificationsDialogComponent } from '@business/notification/components/my-notifications-dialog/my-notifications-dialog.component';
import { MyNotificationsDropdownComponent } from '@business/notification/components/my-notifications-dropdown/my-notifications-dropdown.component';
import { RichPresenceModule } from '@business/rich-presence/rich-presence.module';
import { JumpToCommandComponent } from '@business/search/components/jump-to-command/jump-to-command.component';
import { BackendSystemSwitcherComponent } from './components/backend-system-switcher/backend-system-switcher.component';

@NgModule({
  imports: [
    SharedModule,
    MenuModule,
    RichPresenceModule,
    JumpToCommandComponent,
    MyNotificationsDropdownComponent,
    MyNotificationsDialogComponent,
    ToastComponent,
    MaintenanceMessagesComponent,
    LogLevelCommandComponent,
  ],
  declarations: [
    PortalContainerComponent,
    PortalFooterComponent,
    PortalHeaderComponent,
    PortalPageComponent,
    BackendSystemSwitcherComponent,
    ToastsComponent,
  ],
  exports: [PortalContainerComponent, PortalHeaderComponent],
})
export class PortalModule {}
